(function(){
  var root = document.getElementById('scentQuiz');
  if(!root) return;
  var PRODUCTS = window.FSC_QUIZ_POOL || [];

  var FAMILY = {
    citrus: /citrus|bergamot|lime|lemon|mandarin|orange|marine|aquatic|sugared citrus|black currant|cucumber|crisp/,
    floral: /floral|rose|jasmine|ylang|lavender|cherry blossom|peach|berries|soft florals|iris/,
    woody:  /woody|sandalwood|santal|cedar|cedarwood|tobacco|leather|birch|pine|cypress|sage|tonka|smoky/,
    sweet:  /sweet|vanilla|sugar|cream|coconut|cashmere|marshmallow|whipped|pumpkin|brown sugar|caramel/
  };
  var CHARACTER = {
    sweet:   /vanilla|sugar|cream|coconut|marshmallow|peach|whipped|caramel|brown sugar|sweet/,
    earthy:  /sage|cedar|cedarwood|birch|leather|smoky|fig leaf|matcha|tonka|woody|pine|cypress|herbal|green/,
    powdery: /musk|iris|soft florals|cashmere|ylang|violet|powder|warm milk|clean musk/,
    bright:  /citrus|bergamot|lime|lemon|marine|aquatic|crisp greens|white tea|cucumber|fresh|mandarin/
  };
  var NARROW = {
    citrus: [
      ['lemon',   'Sharp citrus',      'Lemon, lime, mandarin - the wake-up kind.', /lime|lemon|mandarin|citrus/],
      ['marine',  'Sea air',           'Marine, aquatic, clean and open.',          /marine|aquatic|fresh/],
      ['tea',     'Tea &amp; cucumber','Earl grey, white tea, cut cucumber.',       /tea|cucumber|earl grey|matcha/],
      ['fruit',   'Sugared fruit',     'Black currant, peach, sugared citrus.',     /currant|peach|sugared|fruity|berries/]
    ],
    floral: [
      ['rose',    'Rose',              'From vintage and dark to fresh-cut.',       /rose/],
      ['jasmine', 'Jasmine &amp; ylang','Heady, polished, white-floral.',           /jasmine|ylang/],
      ['lavender','Lavender',          'Calm, herbal, dusky.',                      /lavender/],
      ['blossom', 'Blossom &amp; berry','Cherry blossom, peach, soft berries.',     /cherry blossom|peach|berries|soft florals|fruity/]
    ],
    woody: [
      ['santal',  'Sandalwood',        'Creamy santal, cardamom, warm.',            /santal|sandalwood|cardamom/],
      ['leather', 'Leather &amp; smoke','Tonka, leather, smoked amber.',            /leather|smoky|tonka|amber/],
      ['tobacco', 'Tobacco &amp; vanilla','Dried tobacco leaf, warm spice.',        /tobacco|warm spice/],
      ['forest',  'Forest',            'Pine, cypress, cedar, sage.',               /pine|cypress|cedar|sage|birch|fig leaf|green/]
    ],
    sweet: [
      ['vanilla', 'Vanilla',           'Vanilla bean, cream, cashmere musk.',       /vanilla|cream|cashmere/],
      ['sugar',   'Sugar &amp; coconut','Spun sugar, coconut, silk.',               /sugar|coconut/],
      ['spice',   'Baked spice',       'Pumpkin, cinnamon, brown sugar.',           /pumpkin|cinnamon|brown sugar|spice/],
      ['mint',    'Cool &amp; sweet',  'Peppermint, candy cane, whipped vanilla.',  /peppermint|candy cane|mint|whipped/]
    ]
  };
  var MOOD = {
    unwind:   /lavender|calming|sleep|musk|warm milk|vanilla|spa|eucalyptus/,
    entertain:/jasmine|rose|amber|saffron|leather|elegant|luxury|floral/,
    focus:    /citrus|eucalyptus|sage|white tea|crisp|fresh|marine|herbal|green/,
    romance:  /rose|cherry blossom|romantic|peach|jasmine|dark floral|amber/
  };
  var SIZECOPY = {
    small:'<b>Start at 4oz or 8oz.</b> The 4oz is the low-commitment way in - a tester, a favor, a travel tin. The 8oz Signature is the one most people repurchase: 40+ hours on a single black wooden wick.',
    mid:'<b>Go 12oz or 15oz.</b> The 12oz runs 70+ hours on dual wooden wicks and actually fills a living room. The 15oz Centerpiece is the double-wicked showpiece.',
    big:'<b>The 150oz Big + Bougie.</b> 400+ hours, ships with a wick snuffer, and reads as furniture rather than candle. Pick your scent when you order.'
  };
  var FAMNAME = {citrus:'fresh &amp; citrus', floral:'floral', woody:'warm &amp; woody', sweet:'sweet &amp; gourmand'};
  var CHARNAME= {sweet:'sweet', earthy:'earthy and subtle', powdery:'powdery and soft', bright:'bright and clean'};

  function questions(a){
    var q3 = NARROW[a.fam] || NARROW.citrus;
    return [
      { key:'fam', n:'Question 01', q:'Where do you want to start?',
        sub:'Pick the family that pulls you in - we narrow from here.',
        opts:[
          ['citrus','Fresh &amp; citrus','Lemon, bergamot, marine air, cut cucumber.'],
          ['floral','Floral','Rose, jasmine, lavender, cherry blossom.'],
          ['woody','Warm &amp; woody','Sandalwood, tobacco, leather, cedar.'],
          ['sweet','Sweet &amp; gourmand','Vanilla, sugar, coconut, baked spice.']
        ]},
      { key:'char', n:'Question 02', q:'Sweet, or something more restrained?',
        sub:'This is the single biggest fork in the road.',
        opts:[
          ['sweet','Sweet','Vanilla, sugar, cream - comforting and full.'],
          ['earthy','Earthy &amp; subtle','Wood, herbs, smoke. Quiet and grown-up.'],
          ['powdery','Powdery &amp; soft','Musk, iris, cashmere. Clean laundry, but expensive.'],
          ['bright','Bright &amp; clean','Citrus and air. Nothing heavy.']
        ]},
      { key:'note', n:'Question 03', q:'Which of these sounds most like you?',
        sub:'Last narrowing question - then we match.',
        opts: q3.map(function(o){ return [o[0], o[1], o[2]]; }) },
      { key:'mood', n:'Question 04', q:'What is the candle for?',
        sub:'Same scent, different job.',
        opts:[
          ['unwind','Winding down','End of the day, bath, bed, quiet.'],
          ['entertain','Having people over','You want someone to ask about it.'],
          ['focus','Working','Clear-headed, not distracting.'],
          ['romance','Romance','Low light, close quarters.']
        ]},
      { key:'size', n:'Question 05', q:'Where is it burning?',
        sub:'So we point you at the right size.',
        opts:[
          ['small','Desk or bedside','Something you will actually finish. 4-8oz.'],
          ['mid','Living room','Needs to fill the space. 12-15oz.'],
          ['big','It is the decor','The 150oz statement piece.']
        ]}
    ];
  }

  var answers = {}, idx = 0, order = ['fam','char','note','mood','size'];
  var stepsEl = document.getElementById('qSteps');
  var barEl   = document.getElementById('qBar').firstElementChild;
  var backEl  = document.getElementById('qBack');
  var countEl = document.getElementById('qCount');

  /* ---------- SCENT WALL ---------- */
  var wallEl   = document.getElementById('qWall');
  var trackEl  = document.getElementById('qWallTrack');
  var wCountEl = document.getElementById('qWallCount');
  var wNoteEl  = document.getElementById('qWallNote');
  var started  = false;

  function esc(x){ return String(x).split(String.fromCharCode(34)).join('&quot;'); }

  function cardHTML(p, i, dupe){
    var q = String.fromCharCode(34);
    var h = '<a class=' + q + 'wcard' + q + ' href=' + q + p.url + q + ' data-i=' + q + i + q + (dupe ? ' data-dupe=' + q + '1' + q : '') + '>';
    h += '<span class=' + q + 'wframe' + q + '>';
    if(p.img){ h += '<img src=' + q + p.img + q + ' alt=' + q + esc(p.title) + q + ' loading=' + q + 'lazy' + q + '>'; }
    h += '</span><span class=' + q + 'wname' + q + '>' + p.title + '</span></a>';
    return h;
  }

  function buildWall(){
    if(!trackEl || !PRODUCTS.length) return;
    var html = '';
    PRODUCTS.forEach(function(p,i){ html += cardHTML(p,i,false); });
    // duplicate the set so the marquee loops seamlessly
    PRODUCTS.forEach(function(p,i){ html += cardHTML(p,i,true); });
    trackEl.innerHTML = html;
    trackEl.classList.add('marq');
    if(wCountEl) wCountEl.textContent = PRODUCTS.length + ' scents';
  }

  // survivors kept after each answered question
  var KEEP = [null, 16, 10, 6, 4, 3];

  function updateWall(){
    if(!trackEl) return;
    var answered = order.filter(function(k){ return answers[k]; }).length;
    if(answered === 0) return;

    // first answer: stop the marquee, drop the duplicate set, settle into a grid
    if(!started){
      started = true;
      trackEl.classList.remove('marq');
      trackEl.classList.add('grid');
      Array.prototype.slice.call(trackEl.querySelectorAll('[data-dupe]')).forEach(function(el){
        el.parentNode.removeChild(el);
      });
      if(wNoteEl) wNoteEl.textContent = 'narrowing as you answer';
      if(wallEl) wallEl.classList.add('live');
    }

    var keep = KEEP[answered] || 3;
    var ranked = PRODUCTS.map(function(p,i){ return {i:i, s:score(p)}; })
                         .sort(function(a,b){ return b.s - a.s; });
    var alive = {};
    ranked.slice(0, keep).forEach(function(r){ alive[r.i] = true; });

    var live = 0;
    Array.prototype.slice.call(trackEl.querySelectorAll('.wcard')).forEach(function(el){
      var i = parseInt(el.getAttribute('data-i'), 10);
      if(alive[i]){ el.classList.remove('out'); live++; }
      else { el.classList.add('out'); }
    });
    if(wCountEl) wCountEl.textContent = live + (live === 1 ? ' scent left' : ' scents still in');
  }

  function render(){
    var qs = questions(answers), q = qs[idx];
    var html = '<div class=~step on~><div class=~qn~>'+q.n+'</div><div class=~qq~>'+q.q+'</div><div class=~qsub~>'+q.sub+'</div><div class=~qopts~>';
    q.opts.forEach(function(o){
      html += '<button type=~button~ class=~qopt~ data-v=~'+o[0]+'~><b>'+o[1]+'</b><span>'+o[2]+'</span></button>';
    });
    html += '</div></div>';
    stepsEl.innerHTML = html.split('~').join(String.fromCharCode(34));
    barEl.style.width = ((idx)/5*100)+'%';
    countEl.textContent = (idx+1)+' of 5';
    backEl.style.visibility = idx===0 ? 'hidden' : 'visible';

    stepsEl.querySelectorAll('.qopt').forEach(function(b){
      b.addEventListener('click', function(){
        answers[q.key] = b.getAttribute('data-v');
        updateWall();
        if(idx < 4){ idx++; render(); }
        else { finish(); }
      });
    });
  }

  backEl.addEventListener('click', function(){
    if(idx>0){ idx--; delete answers[order[idx]]; render(); updateWall(); }
  });

  function score(p){
    var t = p.tags, s = 0;
    if(answers.fam && FAMILY[answers.fam] && FAMILY[answers.fam].test(t)) s += 5;
    if(answers.char && CHARACTER[answers.char] && CHARACTER[answers.char].test(t)) s += 4;
    var narrow = (NARROW[answers.fam]||[]).filter(function(o){ return o[0]===answers.note; })[0];
    if(narrow && narrow[3].test(t)) s += 6;
    if(answers.mood && MOOD[answers.mood] && MOOD[answers.mood].test(t)) s += 2;
    var isStatement = /big and bougie|oversized candle/.test(t);
    var hasXL       = /statement candle|150oz candle|xl candle/.test(t);
    var isBig       = /15oz|44oz|concrete candle|centerpiece/.test(t);
    if(answers.size==='big'){ if(isStatement){ s += 8; } else if(hasXL){ s += 2; } else { s -= 3; } }
    if(answers.size==='mid'){ if(isBig) s += 3; if(isStatement) s -= 5; }
    if(answers.size==='small'){ if(isStatement||isBig) s -= 5; }
    return s;
  }

  function finish(){
    barEl.style.width='100%';
    var ranked = PRODUCTS.map(function(p){ return {p:p, s:score(p)}; })
                         .sort(function(a,b){ return b.s - a.s; })
                         .slice(0,3);
    var labels = ['Best match','Also you','Wildcard'];
    var out = '';
    ranked.forEach(function(r,i){
      var p = r.p;
      out += '<div class=~card~><a class=~buy~ href=~'+p.url+'~ data-name=~'+esc(p.title)+'~>';
      out += '<div class=~frame~>';
      if(p.img){ out += '<img src=~'+p.img+'~ alt=~'+esc(p.title)+'~ loading=~lazy~>'; }
      out += '<span class=~rank~>'+labels[i]+'</span></div>';
      out += '<div class=~meta~><h3>'+p.title+'</h3><div class=~price~>from '+p.price+'</div><span class=~cta~>Buy this candle</span></div>';
      out += '</a></div>';
    });
    document.getElementById('qGrid').innerHTML = out.split('~').join(String.fromCharCode(34));

    document.getElementById('qProfile').innerHTML =
      'You leaned <b>'+FAMNAME[answers.fam]+'</b>, on the <b>'+CHARNAME[answers.char]+'</b> side.';
    document.getElementById('qSize').innerHTML = SIZECOPY[answers.size];

    document.getElementById('qIntro').style.display='none';
    stepsEl.innerHTML='';
    backEl.style.visibility='hidden';
    countEl.textContent='';
    if(wallEl) wallEl.classList.add('done');
    document.getElementById('qResult').classList.add('show');
    document.getElementById('qResult').scrollIntoView({behavior:'smooth',block:'start'});
  }

  var modal = document.getElementById('qModal');
  document.getElementById('qGrid').addEventListener('click', function(e){
    var a = e.target.closest('a.buy');
    if(!a) return;
    e.preventDefault();
    document.getElementById('qModalName').textContent = a.getAttribute('data-name') + '. Good call.';
    document.getElementById('qGo').setAttribute('href', a.getAttribute('href'));
    document.getElementById('qCopied').textContent = '';
    modal.classList.add('show');
  });
  document.getElementById('qCode').addEventListener('click', function(){
    var t = this.textContent.trim();
    if(navigator.clipboard){ navigator.clipboard.writeText(t); }
    document.getElementById('qCopied').textContent = 'Copied';
  });
  document.getElementById('qX').addEventListener('click', function(){ modal.classList.remove('show'); });
  modal.addEventListener('click', function(e){ if(e.target===modal) modal.classList.remove('show'); });

  document.getElementById('qAgain').addEventListener('click', function(){
    answers={}; idx=0; started=false;
    document.getElementById('qResult').classList.remove('show');
    document.getElementById('qIntro').style.display='';
    if(wallEl){ wallEl.classList.remove('done'); wallEl.classList.remove('live'); }
    if(trackEl){ trackEl.classList.remove('grid'); }
    if(wNoteEl) wNoteEl.textContent = 'every scent in the line-up';
    buildWall();
    render();
    root.scrollIntoView({behavior:'smooth',block:'start'});
  });

  buildWall();
  render();
})();